import { useContext } from "react";
import { SearchStore } from "./SearchStore";
import { SearchStoreContext } from "./SearchStoreContext";

export function useSearchStore(): SearchStore {
    return useContext(SearchStoreContext);
}
